import Vue from 'vue';
import App from './app.vue';
import router from './router';
import { store } from './store';

import './plugins';
import './hooks';
import './vendor';
import './registerServiceWorker';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');

const ignoreWarnMessage = 'The .native modifier for v-on is only valid on components but it was used on <div>.';
Vue.config.warnHandler = (msg, vm, trace) => {
  if (msg === ignoreWarnMessage) {
    msg = '';
    trace = '';
  }
}
